<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.provider_pt") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row
              .form-group.col-12.mb-1
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-search"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getProviderPtGlobalList()"
                  variant="primary"
                  size="sm"
                )
          .card-body
            .row
              .col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                    thead.thead-light
                      tr
                        th.text-center(rowspan=2 width="3%")
                          span #
                        th(rowspan=2 width="10%")
                          span(:title="$t('ui.category')" ) {{ $t('ui.category') }}
                        th(rowspan=2 width="10%")
                          span(:title="$t('ui.provider_code')" ) {{ $t('ui.provider_code') }}
                        th(rowspan=2 width="10%")
                          span(:title="$t('ui.provider_name')" ) {{ $t('ui.provider_name') }}
                        th.text-center(colspan=6 width="10%")
                          span(:title="$t('ui.pt')") {{ $t('ui.pt') }}
                        //- th.text-center(colspan=3 width="10%")
                        //-   span(:title="$t('ui.pt_on')") {{ $t('ui.pt_on') }}
                      tr
                        th.text-center(width="10%")
                          span(:title="$t('ui.pt')") (%)
                        th.text-left(width="10%")
                          span(:title="$t('ui.modified_by')" ) {{ $t('ui.modified_by') }}
                        th.text-right(width="10%")
                          span(:title="$t('ui.modified_date')") {{ $t("ui.modified_date") }}
                        th.text-center(width="10%")
                          span(:title="$t('ui.pt_on')") {{ $t('ui.criteria') }}
                        th.text-left(width="10%")
                          span(:title="$t('ui.modified_by')" ) {{ $t('ui.modified_by') }}
                        th.text-right(width="10%")
                          span(:title="$t('ui.modified_date')") {{ $t("ui.modified_date") }}
                    tbody.clusterize-content
                      tr(v-if="providerPtGlobalList.length == 0")
                        td(colspan="10").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in providerPtGlobalList")
                        td.text-center
                          span(:title="index + 1") {{ index + 1 }}
                        td
                          span(:title="item.category") {{ item.category }}
                        td
                          span(:title="item.provider_code") {{ item.provider_code }}
                        td
                          span(:title="item.provider_name") {{ item.provider_name }}
                        td.text-center
                          b-link.text-decoration-none(href="javascript:void(0)" @click="isAdmin && isEditAccess ? onProviderPtGlobalUpdate(item) : null" :title="$t('ui.update')") {{ item.pt }}
                        td
                          span(:title="item.pt_modified_by") {{ item.pt_modified_by }}
                        td.text-right
                          template(v-if="item.pt_modified_date")
                            span(:title="$moment(item.pt_modified_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.pt_modified_date).format("YYYY-MM-DD, HH:mm:ss") }}
                          template(v-else)
                            span &nbsp;
                        td.text-center
                          template(v-if="isEditAccess")
                            b-form-select.text-center(v-model="item.pt_on" @change="!isAdmin ? null : providerPtOnGlobalUpdate(item, $event)" size="sm" :disabled="!isAdmin")
                              option(value="WINLOSE") {{ $t("ui.winlose") }}
                              option(value="TURNOVER") {{ $t("ui.turnover") }}
                          template(v-else)
                            span(:title="item.pt_on") {{ item.pt_on }}
                        td
                          span(:title="item.pt_on_modified_by") {{ item.pt_on_modified_by }}
                        td.text-right
                          template(v-if="item.pt_on_modified_date")
                            span(:title="$moment(item.pt_on_modified_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.pt_on_modified_date).format("YYYY-MM-DD, HH:mm:ss") }}
                          template(v-else)
                            span &nbsp;

      providerptglobalupdate(ref="providerptglobalupdate" :item="selectedProvider" @clicked="afterProviderPtGlobalUpdate" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import providerptglobalupdate from "@/components/setup/providerPtGlobalUpdate.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    providerptglobalupdate,
  },
  data: () => ({
    loading: false, 
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    providerPtGlobalList: [],
    selectedProvider: null
  }),
  computed: {
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isOperator() {
      return this.$store.getters.accountType === 2;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_providerptglobal");
    }
  },
  mounted: function() {
    this.getProviderPtGlobalList();
  },
  methods: {
    getProviderPtGlobalList: function() {
      let url = config.providerPtGlobalListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.providerPtGlobalList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    onProviderPtGlobalUpdate(e) {
      this.selectedProvider = e;
      this.$refs.providerptglobalupdate.$refs.providerPtGlobalUpdate.show();
    },
    providerPtOnGlobalUpdate: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.provider_pt_on_global_confirm", { name: item.provider_code }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmProviderPtOnGlobalUpdate(item, eventStatus);
          } else {
            this.getProviderPtGlobalList()
          }
        });
    },
    confirmProviderPtOnGlobalUpdate: function(item, status) {
      let url = config.providerPtOnGlobalUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        provider_code: item.provider_code,
        pt_on: item.pt_on
      };

      this.feedback.success = true;
      // this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          // this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$helpers.showDialog(this.$t("ui.combine.provider_pt_global_update"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
              this.getProviderPtGlobalList()
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    onProviderPtOnGlobalUpdate(e) {
      this.selectedProvider = e;
      this.$refs.providerptonglobalupdate.$refs.providerPtOnGlobalUpdate.show();
    },
    afterProviderPtGlobalUpdate: function() {
      this.getProviderPtGlobalList();
      this.$helpers.showDialog(this.$t("ui.combine.provider_pt_global_update"), this.$t("message.success"), "success");
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>